import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Button, Icon, Loader, Menu, Dropdown, Popup } from "semantic-ui-react";
import MediaItem from "~/models/Media/MediaItem";
import IncludeIn from "~/constants/Media/IncludeIn";

@observer
class MediaEditHeader extends Component {
  formRef = null;

  inputRef = null;

  constructor(props) {
    super(props);

    this.formRef = React.createRef();
    this.inputRef = React.createRef();
  }

  onFilesChange(event) {
    const { onFileReady } = this.props;
    const { files } = event.target;

    if (!files && files.length === 0) {
      return;
    }

    for (let i = 0; i < files.length; i += 1) {
      const file = files[i];
      // get an url for the blob
      const url = URL.createObjectURL(file);
      // download the content (blob) from the file url.
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          onFileReady(file, blob);
        });
    }

    // reset the input field by resetting its form.
    if (this.formRef.current) {
      this.formRef.current.reset();
    }
  }

  render() {
    const { tourInbox, uploadEnabled, t, selectedMediaItems, onIncludeInChange } = this.props;
    const mediaLength = selectedMediaItems.length;
    const bothDisabled = mediaLength === 0 || selectedMediaItems.every(m => m.includeIn === IncludeIn.BOTH);
    const galleryDisabled = mediaLength === 0 || selectedMediaItems.every(m => m.includeIn === IncludeIn.GALLERY);
    const neitherDisabled = mediaLength === 0 || selectedMediaItems.every(m => m.includeIn === IncludeIn.NEITHER);

    return (
      <Menu className="media-edit-header">
        {uploadEnabled && (
          <>
            <Menu.Item>
              {/* on button click let's trigger the 'click' event on the input file so it opens up the file selection
                prompt */}
              <Button primary icon onClick={() => this.inputRef && this.inputRef.current.click()}>
                <Icon name="upload" />
                &nbsp;{t("clientPanelMisc:uploadMedia")}
              </Button>
              <form ref={this.formRef}>
                <input
                  ref={this.inputRef}
                  type="file"
                  accept=".jpg,jpeg,.avi,.mov,.mp4"
                  multiple
                  onChange={event => this.onFilesChange(event)}
                />
              </form>
            </Menu.Item>
            <Menu.Item className="secondary">
              {tourInbox.length > 0 ? (
                <span className="media-edit-processing-wrap">
                  <Loader size="mini" active inline />
                  &nbsp;{t("processing")} {tourInbox.length}
                  &nbsp;
                  <Icon name="images" />
                </span>
              ) : (
                <h4>{t("clientPanelMisc:dragDropBelowUpload")}</h4>
              )}
            </Menu.Item>
          </>
        )}
        <Menu.Item className="mediaItemsBulkAction">
          <Popup
            content={t("clientPanelMisc:noMediaSelected")}
            disabled={mediaLength > 0}
            trigger={
              <Dropdown text={`${t("clientPanelMisc:changeVisibility")} (${mediaLength})`}>
                <Dropdown.Menu>
                  <Dropdown.Item
                    disabled={bothDisabled}
                    icon="eye"
                    text={t("clientPanelMisc:bothVirtualTourGallery")}
                    onClick={() => onIncludeInChange(IncludeIn.BOTH)}
                  />
                  <Dropdown.Item
                    disabled={galleryDisabled}
                    icon="image"
                    text={t("clientPanelMisc:galleryOnlyFitZephyr")}
                    onClick={() => onIncludeInChange(IncludeIn.GALLERY)}
                  />
                  <Dropdown.Item
                    disabled={neitherDisabled}
                    icon="eye slash"
                    text={t("clientPanelMisc:neitherVirtualTourNorGallery")}
                    onClick={() => onIncludeInChange(IncludeIn.NEITHER)}
                  />
                </Dropdown.Menu>
              </Dropdown>
            }
          />
        </Menu.Item>
      </Menu>
    );
  }
}

MediaEditHeader.propTypes = {
  tourInbox: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    }),
  ),
  onFileReady: PropTypes.func.isRequired,
  uploadEnabled: PropTypes.bool,
  t: PropTypes.func.isRequired,
  selectedMediaItems: PropTypes.arrayOf(PropTypes.instanceOf(MediaItem)),
  onIncludeInChange: PropTypes.func.isRequired,
};

export default withTranslation()(MediaEditHeader);
